import { useEffect, useState } from 'react';
import { initializeDatabase } from '../db/database';
import { friendlyStorageError } from '../shared/errors';
import { App } from './App';

export function AppBootstrap() {
  const [state, setState] = useState<'loading' | 'ready' | 'error'>('loading');
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    initializeDatabase().then(() => {
      if (active) setState('ready');
    }).catch(reason => {
      if (!active) return;
      setError(friendlyStorageError(reason));
      setState('error');
    });
    return () => { active = false; };
  }, []);

  if (state === 'loading') {
    return <main className="bootstrap-screen" aria-busy="true"><div className="spinner" /><p>Открываем дневник…</p></main>;
  }
  if (state === 'error') {
    return (
      <main className="bootstrap-screen">
        <h1>Не удалось открыть данные</h1>
        <p>{error}</p>
        <button className="button button-primary" type="button" onClick={() => location.reload()}>Повторить</button>
      </main>
    );
  }
  return <App />;
}
